import { usePostMembership } from '#api/member';
import { useToast } from '#providers/ToastProvider';
import { useNavigate, useParams } from 'react-router';
import { useDashboardCustomerMembershipState } from '../dahsboardCustomerMembershipState';
import TagManager from 'react-gtm-module';

export const SaveButton = () => {
  const { personId } = useParams();

  const {
    dashboardCustomerMembershipState,
    setDashboardCustomerMembershipState
  } = useDashboardCustomerMembershipState();

  const { showToast } = useToast();

  const navigate = useNavigate();

  const { mutate } = usePostMembership({
    onSuccess: () => {
      TagManager.dataLayer({
        dataLayer: {
          event: 'customer_membershipadd_new_complete',
          category: '회원관리',
          action: 'customer_membershipadd_new_complete',
          value: 2
        }
      });
      showToast({
        type: 'success',
        message: '수강권이 추가되었습니다.'
      });
      navigate(-1);
      setDashboardCustomerMembershipState({
        lectureId: '',
        sessionDuration: 0,
        round: 0,
        totalRound: 0,
        price: 0,
        isRequestPayment: false,
        startedDate: '',
        expiryPeriod: '',
        expiryDate: '',
        discount: null
      });
    },
    onError: (e: any) => {
      showToast({
        type: 'fail',
        message: e.response.data.message || '수강권 추가에 실패했습니다.'
      });
    }
  });

  const onClickSave = () => {
    if (!personId) return;

    const {
      lectureId,
      sessionDuration,
      round,
      totalRound,
      price,
      startedDate,
      isRequestPayment
    } = dashboardCustomerMembershipState;

    const requiredFields: {
      [K in keyof typeof dashboardCustomerMembershipState]?: (typeof dashboardCustomerMembershipState)[K];
    } = {
      lectureId,
      sessionDuration,
      totalRound,
      price,
      startedDate,
      isRequestPayment
    };

    // 필수 필드 중에서 누락된 필드 이름 리스트를 가져옵니다.
    const missingFields = (
      Object.keys(requiredFields) as Array<keyof typeof requiredFields>
    ).filter(
      key => requiredFields[key] === undefined || requiredFields[key] === ''
    );

    if (missingFields.length > 0) {
      const missingFieldNames = missingFields
        .map(field => {
          switch (field) {
            case 'lectureId':
              return '수업';
            case 'sessionDuration':
              return '수업시간';
            case 'totalRound':
              return '총 회차';
            case 'price':
              return '가격';
            case 'startedDate':
              return '개시 날짜';
            case 'isRequestPayment':
              return '결제 상태';
            default:
              return field;
          }
        })
        .join(', ');

      showToast({
        type: 'fail',
        message: `필수값을 입력해주세요: ${missingFieldNames}`
      });
      return;
    }

    const params = {
      lectureId,
      sessionDuration,
      round,
      totalRound,
      price,
      isRequestPayment,
      startedDate,
      expiryPeriod: null,
      expiryDate: dashboardCustomerMembershipState.expiryDate || null
    };

    mutate({
      personId,
      params
    });
  };

  return (
    <div
      onClick={onClickSave}
      className="text-right text-[#9170f2] text-base font-medium font-['Pretendard Variable'] leading-[21px]"
    >
      저장
    </div>
  );
};
